<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 选商定价 有操作 -->
<template>
  <!-- 0: "定向询价", 1: "公开询价" -->
  <div v-loading="detailLoading" class="choose-business-price">
    <e-process :process-data="processData" :is-active="activeIndex"></e-process>
    <el-form ref="formDom" :model="formData" class="form-content" size="small">
      <!-- 基本信息 -->
      <div class="commodity-list">
        <div class="title">基本信息</div>
        <div class="enquiry-form">
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="询价单名称：" prop="enquiryName">
                <span>{{ formData.enquiryName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="询价类型：" prop="enquiryType">
                <span>
                  {{ formData.enquiryType === 0 ? '定向询价' : formData.enquiryType === 1 ? '公开询价' : '' }}
                </span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="报价限额：" prop="quotationLimit">
                {{ formData.quotationLimit }}
                <span v-if="formData.quotationLimit">元(含税)</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="结算方式：" prop="releaseTime">
                <span>
                  {{ formData.isDoC != undefined ? (formData.isDoC === 1 ? '货到付款' : '款到发货') : '' }}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="配送方式：" prop="quotationDeadline">
                <span>{{ formatShipmentType(formData.shipmentType) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="报价开始时间：" prop="releaseTime">
                <span>{{ formData.releaseTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="报价截止时间：" prop="quotationDeadline">
                <span>{{ formData.quotationDeadline }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="报价开始时间：" prop="releaseTime">
                <span>{{ formData.releaseTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="报价截止时间：" prop="quotationDeadline">
                <span>{{ formData.quotationDeadline }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="是否公示：" prop="whetherPublic">
                <el-radio-group v-model="formData.whetherPublic" disabled>
                  <el-radio :label="0">是</el-radio>
                  <el-radio :label="1">否</el-radio>
                  <!-- <el-tooltip class="right-icon" style="left: 124px" effect="dark" placement="top">
                    <div slot="content">
                      <p>是否把询价结果公示在平台上</p>
                    </div>
                    <div class="icon">?</div>
                  </el-tooltip> -->
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 报价商品分配 -->
      <div v-if="isChoice" class="commodity-list">
        <div class="title">报价商品分配</div>
        <div class="commodity-content">
          <div class="search-box">
            <el-form ref="listQuery" :model="listQuery" size="small" class="search-form" @submit.native.prevent>
              <el-form-item label="供应商名称筛选：" label-width="130px" prop="">
                <el-input
                  v-model="listQuery.supplierCompany"
                  placeholder="供应商名称筛选"
                  @keyup.enter.native="handleSearch()"
                ></el-input>
              </el-form-item>
              <el-form-item label-width="10px">
                <div class="search-btn">
                  <div class="btn reset-btn" size="small" @click="handleReset">重置</div>
                  <div class="btn submit-btn" size="small" @click="handleSearch">查询</div>
                  <div
                    v-if="isCompareBtn && formData.createSource !== 2"
                    class="btn submit-btn price-btn"
                    size="small"
                    style="position: relative; right: -50px; top: 0"
                    @click="handlePrint"
                  >
                    报价对比表
                  </div>
                  <div
                    v-if="formData.createSource !== 2"
                    class="btn submit-btn price-btn"
                    size="small"
                    style="position: relative; right: -60px; top: 0"
                    @click="exportSupplierOffer"
                  >
                    导出报价明细
                  </div>
                  <div
                    v-if="formData.createSource !== 2"
                    class="btn submit-btn"
                    size="small"
                    style="position: relative; right: -70px; top: 0"
                    @click="goHistory"
                  >
                    历史报价对比
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <!-- table -->
          <div class="table-content">
            <el-table
              :data="tableData"
              border
              max-height="455"
              style="width: 100%"
              :header-cell-style="{ background: '#F5F5F5' }"
              size="small"
              current-row-key="index"
            >
              <el-table-column label="选择" width="50px" align="center">
                <template slot-scope="scope">
                  <el-radio
                    v-model="currentRow"
                    disabled
                    :label="scope.row.supplierCompanyId"
                    @change.native="getCurrentRow(scope.row)"
                  ></el-radio>
                </template>
              </el-table-column>
              <el-table-column
                label="供应商名称"
                min-width="220"
                align="center"
                prop="supplierCompany"
              ></el-table-column>
              <el-table-column
                v-if="isShowOfferAmount"
                label="报价总价(元)"
                min-width="120"
                align="center"
                prop="offerAmount"
              ></el-table-column>
              <el-table-column label="报价状态" min-width="110" align="center">
                <template #default="scope">
                  <span>
                    {{ offerStatusEN(scope.row.offerStatus) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                label="报价有效期"
                min-width="150"
                align="center"
                prop="quotationValidity"
              ></el-table-column>
              <el-table-column label="报价时间" min-width="150" prop="createTime" align="center"></el-table-column>
              <el-table-column label="联系人" min-width="180" align="center" prop="offerRealName"></el-table-column>
              <el-table-column label="联系方式" min-width="110" align="center" prop="offerMobile"></el-table-column>
              <el-table-column prop="offerEmail" label="邮箱" min-width="180" align="center"></el-table-column>
              <el-table-column
                :key="2"
                prop="scoreAll"
                label="易派客标准指数"
                min-width="130"
                align="center"
              ></el-table-column>
              <el-table-column :key="3" prop="value" label="产品质量评价" width="100px" align="center">
                <template #default="scope">
                  <span class="add-sup" @click="companyDetail(scope.row.supplierCompanyId)">查看详情</span>
                </template>
              </el-table-column>

              <el-table-column
                :key="4"
                prop="creditGrade"
                label="法人信用认证"
                width="100px"
                align="center"
              ></el-table-column>

              <el-table-column :key="5" prop="compliance" label="履约动态考评" width="150px" align="center">
                <template #default="scope">
                  <el-rate v-model="scope.row.compliance / 5" disabled text-color="#ee9900"></el-rate>
                </template>
              </el-table-column>

              <el-table-column :key="6" prop="innovationEvaluate" label="市场业绩表现" width="150px" align="center">
                <template #default="scope">
                  <el-rate v-model="scope.row.innovationEvaluate" disabled text-color="#ff9900"></el-rate>
                </template>
              </el-table-column>

              <el-table-column label="附件" width="220px" align="center">
                <template slot-scope="scope">
                  <div>
                    <div
                      v-for="item of scope.row.supplierOfferAttachmentList"
                      :key="item.attachmentUrl"
                      class="table-handle-btn"
                      @click="
                        downloadFile({
                          fileName: item.attachmentName,
                          fileUrl: item.attachmentUrl,
                        })
                      "
                    >
                      {{ dealAttachmentName(item.attachmentName) }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="130px" align="center" fixed="right">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.offerStatus !== 0"
                    class="table-handle-btn"
                    @click="openDetailDia(scope.$index, scope.row)"
                  >
                    查看详情
                  </span>
                  <!--  -->
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="询价磋商是采购商、供应商双方对报价进行反复协商，最终达成一致的过程。"
                    placement="top-end"
                  >
                    <span
                      v-if="scope.row.isCanConsult === 1 || scope.row.offerStatus === 4"
                      class="table-handle-btn"
                      @click="openNegotiationDialog(scope.row)"
                    >
                      发起磋商
                    </span>
                  </el-tooltip> -->
                  <span v-if="scope.row.isShowConsultRecord === 1" class="table-handle-btn" @click="goUrl(scope.row)">
                    磋商记录
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 供应商信息 -->
      <div class="commodity-list" style="margin-top: 10px">
        <div class="title">个人信息</div>
        <div class="enquiry-form">
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="期望到货日期：" prop="arrivalTime">
                <span>{{ formData.arrivalTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="联系人：" prop="realName">
                <span>{{ formData.realName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label-width="142px" label="联系方式：" prop="mobile">
                <span>{{ formData.mobile }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="142px" label="邮箱：" prop="email">
                <span>{{ formData.email }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="收货地址：" prop="address">
                <span>{{ formData.address }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="备注：" prop="address">
                <span>{{ formData.enquiryRemark }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="附件：" prop="address">
                <el-tooltip
                  v-for="item of enquiryAttachmentUrlShow"
                  :key="item.fileUrl"
                  effect="dark"
                  :content="item.fileName"
                  placement="bottom"
                  :disabled="checkTextOverflow(item.fileName)"
                >
                  <span class="file-name" @click="downloadFile(item)">
                    {{ item.fileName }}
                  </span>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-if="[5, 7, 12].includes(formData.enquiryStatus)" class="commodity-list" style="margin-top: 10px">
        <div class="title">备注及附件信息</div>
        <div class="enquiry-form">
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="备注：" prop="arrivalTime">
                <span class="selectivePricingRemark">{{ formData.selectivePricingRemark }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label-width="142px" label="附件：">
                <el-tooltip
                  v-for="item of formData.selectivePricingAttachmentList || []"
                  :key="item.attachmentUrl"
                  effect="dark"
                  :content="item.attachmentName"
                  placement="bottom"
                  :disabled="checkTextOverflow(item.attachmentName)"
                >
                  <span
                    class="file-name"
                    @click="
                      downloadFile({
                        fileName: item.attachmentName,
                        fileUrl: item.attachmentUrl,
                      })
                    "
                  >
                    {{ item.attachmentName }}
                  </span>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

      <div v-if="!isHiddenAgreement" class="commodity-list" style="margin-top: 10px">
        <div class="title">询比价服务协议</div>
        <div class="commodity-content">
          <el-row>
            <el-col :span="12">
              <el-form-item label-width="100px" label="服务协议：" prop="enquiryType" style="margin: 0">
                <eui-btn type="link" @click="quotationNoticeVisible = true">《易派客平台询比价服务协议》</eui-btn>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <quotation-notice-dialog
      v-if="quotationNoticeVisible"
      protocol-type="purchaser"
      :quotation-notice-visible="quotationNoticeVisible"
      is-view
      :rate-num="rateNum"
      @closeDialog="handleCloseDialog"
    />
    <supplier-detail
      :supplier-detail-visible.sync="supplierDetailVis"
      :params="detailParams"
      :offer-amount="offerAmount"
    />
    <el-dialog width="36%" title="产品质量评价详情" :visible.sync="detailVisible" append-to-body>
      <el-table
        v-loading="detailLoading"
        :data="detailTableData"
        height="252"
        border
        size="small"
        style="width: 100%"
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column prop="categoryDescription" label="商品类目" min-width="180" align="center"></el-table-column>
        <el-table-column
          prop="productEvaluate"
          label="产品质量评价分数"
          min-width="180"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="flex-r margin-t10">
        <el-pagination
          :pager-count="5"
          layout="total, prev, pager, next"
          :current-page="detailQuery.pageNum"
          :total="detailTotal"
          :small="true"
          :page-size.sync="detailQuery.pageSize"
          @size-change="detailHandleSizeChange"
          @current-change="detailHandleCurrentChange"
        ></el-pagination>
      </div>
    </el-dialog>

    <!-- 发起磋商 弹窗 -->
    <prompt-modal
      :prompt-modal-visible="negotiationVisible"
      :footer="true"
      width="560px"
      @close="closeDia('negotiationVisible')"
    >
      <div slot="title" class="prompt-modal-title">
        <p style="text-align: left; padding-left: 20px">发起磋商</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <el-form
          ref="negotiationForm"
          :model="negotiationForm"
          :rules="negotiationRules"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="供应商名称" prop="supplierCompany">
            <span>{{ negotiationForm.supplierCompany }}</span>
          </el-form-item>
          <el-form-item label="磋商截至日期" prop="consultDeadline">
            <el-date-picker
              v-model="negotiationForm.consultDeadline"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              :picker-options="pickerReleaseTimeDatew"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注信息" prop="consultRemark">
            <el-input
              v-model="negotiationForm.consultRemark"
              type="textarea"
              maxlength="300"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="hint">提示：发起磋商后，供应商可重新报价，对同一供应商最多支持三轮磋商报价。</div>
      </div>
      <div slot="footer">
        <el-button class="btn-80-30" @click="closeDia('negotiationVisible')">取消</el-button>
        <el-button
          v-prevent-re-click
          class="btn-80-30-primary"
          type="primary"
          @click="handleNegotiation('negotiationVisible')"
        >
          确定
        </el-button>
      </div>
    </prompt-modal>
  </div>
</template>
<script>
import Api from '@/modules/projectA/api/enquiry';
import EProcess from '@/modules/projectA/components/common/e-process.vue';
import utils, { dealAttachmentName } from '@/modules//projectA/utils/utils';
import _ from 'lodash';
import PromptModal from '@/modules/projectA/components/common/promptModal.vue';
import quotationNotice from '@/modules/projectA/components/enquiry/quotationNotice';
import hideCompanyMixin from '@/modules/projectA/components/enquiry/hideCompanyMixin';
import SupplierDetail from './supplierDetail.vue';

export default {
  components: {
    EProcess,
    SupplierDetail,
    PromptModal,
  },
  mixins: [quotationNotice, hideCompanyMixin],
  props: {
    isChoice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const enquiryTypeObj = {
      0: '定向询价',
      1: '公开询价',
    };
    return {
      negotiationVisible: false,
      negotiationForm: {
        consultRemark: '',
        consultDeadline: '',
        supplierCompany: '',
      },
      negotiationRules: {
        consultDeadline: [{ required: true, message: '请选择时间', trigger: 'change' }],
      },
      pickerReleaseTimeDatew: {
        disabledDate: (time) => {
          /* const endTime = this.formData.endTimeSelf;
          if (endTime) {
            return (
              //  - 8.64e7
              time.getTime() > new Date(endTime).getTime() || time.getTime() <= Date.now() - 8.64e7
            );
          } */
          return time.getTime() <= Date.now() - 8.64e7;
        },
      },
      detailTotal: 0,
      detailQuery: {
        pageNum: 1,
        pageSize: 10,
        companyId: -1,
      },
      detailVisible: false, // 产品质量评价 查看详情 弹框
      detailTableData: [], // 产品质量评价 查看详情 弹框 详情列表参数
      detailLoading: false,
      offerAmount: 0,
      activeIndex: 1,
      detailParams: {},
      supplierDetailVis: false,
      processData: [
        {
          itemName: '发布询价需求',
          title: '发布询价需求',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '供应企业报价',
          title: '供应企业报价',
          tip: '',
          description: '',
          icon: '',
        },
        {
          itemName: '选商定价',
          title: '选商定价',
          tip: '',
          description: '',
          icon: '',
        },
        /* {
          itemName: '中选确认',
          title: '中选确认',
          tip: '',
          description: '',
          icon: '',
        }, */
        {
          itemName: '结果公示',
          title: '结果公示',
          tip: '',
          description: '',
          icon: '',
        },
      ],
      currentRow: -1,
      listQuery: {
        offerOrNot: 1,
        pageNum: 1,
        pageSize: 100,
        enquiryId: '',
        supplierCompany: '',
        orderByRule: 0, // 0 正序; 1倒序
      },
      enquiryTypeObj,
      // 列表验证+列表数据
      formData: {
        brandNameX: '',
        enquiryType: 1,
      },
      tableData: [
        /* {
          myTest: "撒大声地",
          brandName: "",
          productName: "",
          specifications: "",
          productDescription: "",
          requiredQuantity: "",
          unitName: ""
        } */
      ],
      enquiryAttachmentUrlShow: [],
      enquiryStatus: -1,
      quotationNoticeVisible: false,
    };
  },
  computed: {
    // 1、已揭示、询价完成、生成订单状态也可以查看供应商报价对比表
    isCompareBtn() {
      const arr = [4, 5, 7];
      return arr.includes(this.enquiryStatus);
    },
    isShowOfferAmount() {
      return this.formData.viewOfferCount && this.formData.viewOfferCount > 0;
    },
  },
  mounted() {
    const { enquiryId } = this.$route.query;
    this.listQuery.enquiryId = Number(enquiryId);
    this.getDetailInfo({ enquiryId: Number(enquiryId) });
    if (this.isChoice) {
      const { enquiryId } = this.$route.query;
      this.getCenterList({
        enquiryId: Number(enquiryId),
        pageNum: 1,
        pageSize: 100,
        orderByRule: 0,
      });
    }
  },
  methods: {
    openNegotiationDialog(row) {
      const { supplierOfferId = '', supplierCompany = '' } = row;
      this.negotiationVisible = true;
      this.negotiationForm.supplierOfferId = supplierOfferId;
      this.negotiationForm.supplierCompany = supplierCompany;
      // this.negotiationForm.consultDeadline = row.quotationValidity;
      this.formData.endTimeSelf = row.quotationValidity;
    },
    handleNegotiation: _.debounce(function (type) {
      this.$refs.negotiationForm.validate(async (valid) => {
        if (valid) {
          try {
            const { enquiryId = '' } = this.listQuery;
            const result = await Api.addSupplierOfferConsult({
              ...this.negotiationForm,
              enquiryId,
            });
            if (result.code === '200') {
              if (this.isChoice) {
                this.getCenterList(this.listQuery);
              }
            }
          } catch (error) {
          } finally {
            this.closeDia(type);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }, 500),
    closeDia(type) {
      this[type] = false;
      if (type === 'negotiationVisible') {
        this.$refs.negotiationForm.resetFields();
        console.log(this.negotiationForm, 'negotiationForm');
      }
    },
    goUrl(row) {
      const { enquiryId = '', supplierOfferId = '' } = row;
      this.$router.push({
        path: '/enquiryManage/enquiry/negotiationRemark',
        query: {
          enquiryId,
          supplierOfferId,
        },
      });
    },
    handlePrint() {
      const { enquiryId } = this.$route.query;
      const { href } = this.$router.resolve({
        path: '/enquiryOrder',
        query: { enquiryId },
      });
      window.open(href, '_blank');
    },
    checkTextOverflow(str) {
      let count = 0; // 初始化字节数递加变量并获取字符串参数的字符个数
      if (str) {
        // 如果存在字符串，则执行
        for (let i = 0; i < str.length; i++) {
          if (str.charCodeAt(i) > 255) {
            // 字符编码大于255，说明是双字节字符(即是中文)
            count += 2;
          } else {
            count++;
          }
        }
      }
      return count <= 20;
    },
    // 概要导出
    exportSupplierOffer: _.debounce(async function () {
      const { enquiryId } = this.$route.query;
      const { supplierCompany = '' } = this.listQuery;
      this.exportFlag = true;
      const res = await Api.exportSupplierOffer({
        supplierCompany,
        enquiryId,
      });
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '供应商报价明细表');
      }
    }),
    // 处理市场业绩
    handleInnovationEvaluate(score) {
      if (score >= 0 && score < 10) {
        return 1;
      }
      if (score >= 10 && score < 20) {
        return 2;
      }
      if (score >= 20 && score < 40) {
        return 3;
      }
      if (score >= 40 && score < 60) {
        return 4;
      }
      if (score >= 60) {
        return 5;
      }
    },
    detailHandleCurrentChange(val) {
      this.detailQuery.pageNum = val;
      this.getCompanyDetailList(this.detailQuery);
    },
    detailHandleSizeChange(val) {
      this.detailQuery.pageSize = val;
      this.detailQuery.pageNum = 1;
      this.getCompanyDetailList(this.detailQuery);
    },
    // 获取公司详情数据
    async getCompanyDetailList(params) {
      this.detailLoading = true;
      await Api.queryCompanyProductGradePage(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          const list = res.data?.records;
          this.detailTableData = [...list];
          this.detailTotal = res.data?.total;
        }
      });
    },
    // 内层弹窗
    companyDetail(companyId) {
      this.detailQuery.companyId = companyId;
      this.detailVisible = true;
      this.getCompanyDetailList(this.detailQuery);
    },
    dealAttachmentName,
    downloadFile(fileObj) {
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileObj.fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileObj.fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    goHistory() {
      this.$router.push({
        path: '/enquiryManage/enquiry/historyContrast',
        query: {
          enquiryId: this.listQuery.enquiryId,
        },
      });
    },
    offerStatusEN(offerStatus) {
      const offerStatusObj = {
        0: '待报价',
        1: '已报价',
        2: '已选入',
        3: '未选入',
        4: '过期',
        5: '作废',
        6: '磋商中',
        7: '中选通知待确认',
      };
      return offerStatusObj[offerStatus];
    },
    sort() {
      this.listQuery.orderByRule = this.listQuery.orderByRule === 0 ? 1 : 0;
      if (this.isChoice) {
        this.getCenterList(this.listQuery);
      }
    },
    openDetailDia(index, row) {
      const { supplierOfferId, enquiryId } = row;
      this.detailParams.enquiryId = enquiryId;
      this.detailParams.supplierOfferId = supplierOfferId;
      this.supplierDetailVis = true;
      this.offerAmount = row.offerAmount;
    },
    goBack() {
      this.$router.push({
        path: '/enquiryManage/enquiry/',
      });
    },
    async getCenterList(params) {
      // queryOfferListByPage 中间选商列表接口
      await Api.queryOfferListByPage(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          // this.formData =
          this.tableData = res.data?.records;
          this.tableData = this.tableData.filter((item) => item.offerStatus !== 5);
          this.tableData.forEach((item) => {
            if (item.innovationEvaluate) {
              item.innovationEvaluate = this.handleInnovationEvaluate(item.innovationEvaluate);
            }
          });
          // scope.row.offerStatus == 2

          this.tableData.forEach((item) => {
            if ([12, 14].includes(this.enquiryStatus) && item.selectedStatus === 1) {
              this.currentRow = item.supplierCompanyId;
            } else if (item.offerStatus === 2) {
              this.currentRow = item.supplierCompanyId;
            }
          });
          console.log(res.data, '辅导辅导辅导');
        }
      });
    },
    // 采购商-查询询价单详情
    async getDetailInfo(params) {
      this.detailLoading = true;
      await Api.queryEnquiryDetailByEnquiryId(params).then((res) => {
        this.detailLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.getRateNum(data);
          this.formData = data;
          this.enquiryStatus = data.enquiryStatus;
          this.$emit('getCreateSource', data.createSource);
          // 展示转换
          if (data.enquiryAttachmentList?.length) {
            const enquiryAttachmentUrlShow = data.enquiryAttachmentList;
            this.enquiryAttachmentUrlShow = enquiryAttachmentUrlShow.map((item) => ({
              fileUrl: item.attachmentUrl,
              fileName: item.attachmentName,
            }));
          }

          const { enquiryStatus } = this.formData;
          switch (enquiryStatus) {
            case 0:
            case 1:
            case 9:
              this.activeIndex = 1;
              break;
            case 2:
            case 3:
            case 4:
              this.activeIndex = 2;
              break;
            case 5:
            case 14:
            case 12:
              this.activeIndex = 3;
              break;
            case 6:
            case 7:
              this.activeIndex = 4;
              break;
            case 8:
            case 10:
              this.activeIndex = -1;
              break;
            default:
              this.activeIndex = -1;
              break;
          }

          // 封装发起审批人数据
          const firstData = {
            step: '发起审批',
            icon: require('@/assets/img/approval/fqsp.png'),
            auditStatus: 1,
            nodeMember: {
              auditMemberPhone: this.formData.mobile,
              auditMemberName: this.formData.createMemberName,
              approveTime: this.formData.createTime,
            },
          };

          // 选商定价发起人数据
          const setPriceFirstData = {
            step: '发起审批',
            icon: require('@/assets/img/approval/fqsp.png'),
            auditStatus: 1,
            nodeMember: {
              auditMemberPhone: this.formData.selectivePriceAuditMobile,
              auditMemberName: this.formData.selectivePriceAuditMemberName,
              approveTime: this.formData.selectPriceAuditTime,
            },
          };
          // 封装最后节点数据
          const lastData = {
            enquiryStatus: this.formData.enquiryStatus,
            refuseReason: this.formData.refuseReason,
          };

          this.$emit(
            'queryAuditBusinessFlowLogList',
            firstData,
            lastData,
            setPriceFirstData,
            this.formData.purchaseCompanyId
          );
        }
      });
    },
    getCurrentRow(row) {
      console.log(row);
      this.currentRow = row.supplierCompanyId;
    },
    // 搜索
    handleSearch() {
      this.listQuery.pageNum = 1;

      if (this.isChoice) {
        this.getCenterList(this.listQuery);
      }
    },
    // 重置
    handleReset() {
      this.listQuery.supplierCompany = '';
      this.listQuery.pageNum = 1;
      this.listQuery.orderByRule = 0; // 0 正序; 1倒序
      if (this.isChoice) {
        this.getCenterList(this.listQuery);
      }
    },
    // 开课时期
    startClassChange(courseDay) {
      this.formData.quotationDeadline = courseDay || '';

      if (courseDay) {
        courseDay && this.endClassChange(courseDay + 13 * 24 * 3600 * 1000);
      }
    },
    // 节课时期
    endClassChange(endCourseDay) {
      this.formData.arrivalTime = endCourseDay || '';
    },
    formatShipmentType(type) {
      let str = '';
      if (type === 1) {
        str = '卖家自行配送';
      } else if (type === 3) {
        str = '第三方物流';
      }
      return str;
    },
  },
};
</script>
<style lang="scss">
.el-dialog {
  .el-dialog__body {
    padding: 10px;
    .pagination-box {
      text-align: center;
      margin-top: 10px;
      .el-pagination {
        button {
          height: 30px;
          color: #999;
        }
        .el-select {
          .el-input__inner {
            border-radius: 0;
            height: 30px;
          }
        }
        .el-input__inner {
          border-radius: 0;
          height: 30px;
          color: #999;
        }
        .el-select-dropdown__item,
        .el-pagination__jump,
        .el-pagination__total {
          height: 28px;
          line-height: 28px;
          color: #999;
          float: right;
        }
        .el-pager {
          li {
            border-radius: 0;
            border: 1px solid #d9d9d9;
            line-height: 28px;
            text-align: center;
            margin-left: 10px;
            width: 40px;
            height: 30px;
            color: #999;
            &:first-child {
              margin-left: 0;
            }
            &.active {
              background: #2587ff;
              border: none;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.choose-business-price {
  background: #fff;
  ::v-deep .el-table__row .cell {
    .el-radio {
      .el-radio__label {
        display: none;
      }
    }
  }
  .form-content {
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      .el-input__inner {
        border-radius: 0;
      }
    }
  }
  .add-sup {
    color: #0064c8;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .commodity-list {
    border: 1px solid #f5f5f5;
    &:last-child {
      margin-top: 10px;
    }

    .title {
      height: 40px;
      line-height: 40px;
      background: #f5f5f5;
      padding-left: 20px;
    }
    .commodity-content {
      padding: 10px;
      .search-box {
        .search-form {
          display: flex;
          justify-content: center;
          align-items: center;
          background: #fff;
        }

        ::v-deep .el-form-item--small.el-form-item {
          margin-bottom: 10px;
          margin-right: 20px;
        }
        .search-btn {
          display: flex;
          flex-direction: row;
          justify-content: center;
          position: relative;

          .btn {
            min-width: 80px;
            text-align: center;
            height: 30px;
            line-height: 27px;
            padding: 0 10px;
            cursor: pointer;
          }

          .default-btn {
            background: #fff;
            border: 1px solid #dcdfe6;
            margin-right: 50px;
          }

          .reset-btn {
            background: #e8efff;
            border: 1px solid #2587ff;
            color: #2587ff;
            margin-right: 10px;
            line-height: 27px;
            &:hover,
            :active {
              background-color: #126edf;
              color: #fff;
            }
          }
          .submit-btn {
            background: #2587ff;
            border: 1px solid #2587ff;
            color: #ffffff;
            &:hover,
            :active {
              background-color: #126edf;
            }
          }
        }
      }
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }
      .handle-btn {
        margin: 10px 0;
        .el-button {
          border-radius: 0;
        }
      }
      .table-content {
        ::v-deep .el-table th.must div:before {
          content: '*';
          color: #ff1818;
        }

        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
      }
      .table-handle-btn {
        color: #0064c8;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .enquiry-form {
      padding: 10px;
      ::v-deep .el-form-item {
        margin-bottom: 0;
      }

      .selectivePricingRemark {
        white-space: pre-wrap;
        word-break: break-all;
      }

      .file-name {
        margin-right: 10px;
        color: #0064c8;
        cursor: pointer;
        display: inline-block;
        width: 150px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        flex-shrink: 0;
        flex-grow: 0;
      }
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }

      ::v-deep .el-upload {
        display: block;
      }
      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    .back-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }
    .right-btn {
      display: flex;
    }
    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 10px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .pagination {
    margin-top: 18px;
  }
  .warning-content {
    display: flex;
    align-items: center;
    line-height: 56px;
    background: #fffce8;
    padding-left: 10px;
    margin-top: 10px;
    &::before {
      content: '*';
      color: #f0250f;
    }
  }
}
</style>
